import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";

export default function ProductsCampaign() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/campaign.png"
          alt="Campaign"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">Campaign</div>
      </div>

      <div>
        <p className="fs-5 mt-3">A window to the world of your customers</p>
        <p className="fs-5 ">
          Business is about communications and the easier you make those
          communications the better your business.
        </p>
        <p className="fs-5 ">
          Campaign gives your organisation another managed communications
          channel for your customers to use, and without a heavy cost.
        </p>
        <p className="fs-5 ">
          Imagine if they could text in (rather than call) while on the move to
          get your address, find the nearest branch, book a table or an
          appointment, advise if running late, request help, engage with support
          or self-manage their own contact details? These services and a great
          deal more are all possible with Campaign either as standalone service
          or integrated into Logic and utilising API’s.
        </p>
        <p className="fs-5 ">
          Many customers prefer to self-serve and only need the ability to
          achieve this, and if done right will reengage every time.
        </p>
        <p className="fs-5 ">
          The delivery of such a services represents substantial saving to any
          organisation, improved customer experience and often an uptick in
          business.
        </p>
        <p className="fs-5 ">
          Campaign can be used as simply or as complex as your organisation
          requires, for example simply forwarding inbound requests into CRM
          systems or group email boxes, (can be used in conjunction with
          boomMail) or using auto response to guide the user into a carefully
          choreographed construct that allows them to fulfil their need, or seek
          for further help.
        </p>
        <p className="fs-5 ">
          Campaign is the perfect example of a high value, lightweight,
          inexpensive and out of the box service that can start small and be
          built up to become a critical part of your organisation’s interaction
          with your customers and stakeholder alike.
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
